"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ActionLink = require("./components/ActionLink");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  children: _propTypes.node.isRequired,
  icon: _propTypes.node
} : {};
const defaultProps = {
  component: 'a'
};

const ActionLink = _react.default.forwardRef(function (props, ref) {
  const {
    component,
    className,
    icon: Icon,
    ...other
  } = props;
  return (0, _core.jsx)(_ActionLink.ActionLink, (0, _extends2.default)({
    as: component,
    ref: ref,
    className: className
  }, other), props.children, Icon && (0, _core.jsx)(Icon, {
    color: "#3377BB",
    width: "32px",
    height: "32px"
  }));
});

exports.ActionLink = ActionLink;
process.env.NODE_ENV !== "production" ? ActionLink.propTypes = propTypes : void 0;
ActionLink.defaultProps = defaultProps;